import styled from 'styled-components';
import { Subtitle, Paragraph } from '../../global/typography';

export const StyledSubtitle = styled.h3`
    font-weight: 600;
    font-size: 21px;
    line-height: 31.5px;
    margin-bottom: 0.94rem;
    text-align: start;
    font-weight: 600;
`;

export const Line = styled.div`
    width: 30px;
    height: 3px;
    background-color: black;
    margin-bottom: 20px;
`;

export const StyledTextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LinkContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledParagraph = styled(Paragraph)`
    margin: 0;
    margin-bottom: 20px;
`;

export const StyledLink = styled.a`
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
    font-size: 1rem;
    line-height: 1.125;
    font-style: normal;
    margin-bottom: 30px;
    font-weight: 600;

    &:hover {
        text-decoration: none;
        color: ${props => props.theme.colors.primary};
    }
`;
